import axios from '@/utils/axios.js'

/**
 * 用户-提交留言建议
 * @param {Object} data { type, content }
 * @returns {Promise}
 */
export async function addUserMessage(data) {
  const { data: res } = await axios.post('/mangaCenter/userMessage/add', data)
  return res
}

/**
 * 用户-获取自己的留言列表
 * @param {Object} params { pageNo, pageSize }
 * @returns {Promise}
 */
export async function getUserMessageList(params) {
  const { data } = await axios.get('/mangaCenter/userMessage/user/list', { params })
  return data
}
